import React, { useCallback, useEffect } from 'react'
import { useDropzone } from 'react-dropzone'
import { DragZone, TextDrag } from "./styled.components";
import { useState } from 'react';
import { hotToast } from 'utils';
import { FaCloudUploadAlt } from "react-icons/fa";

const DragFile = ({ setterFunc, file, disabled }:any) => {
    const [fileData, setFileData] = useState(null);
    const [urlFile, setUrlFile] = useState('');
    const [fileName, setFileName] = useState(null)

    useEffect(() => {
        if (file) {
            setUrlFile('url(' + file + ')')
        }
    }, [file])


    const fileTypes = 'csv|txt|xls|xlsx'

    const onDrop = useCallback((acceptedFiles:any) => {
        const fileUploaded = acceptedFiles[0];
        if (fileUploaded) {
            const re = RegExp('\\.(' + fileTypes + ')$', 'i');
            if (re.test(fileUploaded.name)) {
                /* if(fileUploaded.size > 5000000){
                    hotToast("")
                    storeToast.handleToast({
                        title:"Error",
                        message: "La imagen no puede ser superior a 5mb",
                        severy: "error",
                    });
                    return null;
                } */
                

                let reader = new FileReader();
                reader.onload = (event:any) => {
                    setUrlFile('url(' + event.target.result + ')')
                    setFileData(event.target.result)
                };
                reader.readAsDataURL(fileUploaded)
                setFileName(fileUploaded.name)
                setterFunc(fileUploaded);
            } else {
                hotToast("El formato de imagen no es valido","ERROR")
            }
        } else {
            hotToast("El formato de imagen no es valido","ERROR")
        }
    }, []);


    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        maxFiles: 1,
        multiple: false,
        accept: {
            'text': ['.csv','.txt'],
            'application/vnd.ms-excel': ['.xls', '.xlsx'],
        },
        onDrop,
        disabled
    })


    return (
        <>
            <DragZone  {...getRootProps()} image={urlFile}>
                <input {...getInputProps()} />
                {
                    disabled
                        ? ''
                        : isDragActive ?
                            <TextDrag>Suelta el archivo aquí...</TextDrag> :
                            <TextDrag>
                                { fileName ? 'Arrastra o da click para cambiar' : 'Da click para seleccionar archivo'}
                                <FaCloudUploadAlt />
                                { fileName ? fileName : 'Ó mover el archivo aquí'}
                            </TextDrag>
                }
            </DragZone>
        </>

    )
}

export default DragFile